<!-- eslint-disable vue/no-v-html -->
<template>
	<section
		class="main-section"
		:class="['py-5 px-5']"
		:style="sectionStyle()">
		<b-container>
			<h2
				class="bolder-text text-center mb-4"
				v-html="title" />
			<div
				class="row g-4">
				<div
					v-for="(item, idx) in items"
					:key="'key-ing-'+idx"
					class="col-md-4"
					:class="{ 'mb-2': ['xs', 'sm'].includes(windowWidth) }">
					<div class="key-ing-card p-3 h-100 text-center mb-2">
						<img
							:src="item.image"
							alt="Key Ingredient"
							class="img-fluid key-ing-image mb-3">
						<h5
							class="bolder-text mb-2"
							v-html="item.title" />
						<p
							v-if="item.description"
							class="mb-0 small"
							v-html="item.description" />
					</div>
				</div>
			</div>
		</b-container>
	</section>
</template>

<script>
import { JnsLandingPages } from '@/translations';
import WindowSizes from '@/mixins/WindowSizes';

export default {
	name: 'KeyIngredientsSection',
	messages: [JnsLandingPages],
	mixins: [WindowSizes],
	props: {
		title: {
			type: String,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
		backgroundColor: {
			type: String,
			required: true,
		},
	},
	methods: {
		sectionStyle() {
			return {
				backgroundColor: this.backgroundColor,
				borderRadius: '8px',
				padding: '2rem 1rem',
			};
		},
	},
};
</script>

<style scoped>
.key-ing-card {
	background: #fff;
	color: #333;
	border-radius: 8px;
	box-shadow: 0 6px 18px rgba(0,0,0,.08);
}
.key-ing-image {
	max-height: 180px;
	object-fit: contain;
}
.bolder-text { font-weight: bolder; }
</style>
